import { NAV_GROUPS, DISTRIBUTOR_ADMIN_GROUPS } from '../data/navigation';
import {
  canLogInToWeb,
  isAdmin,
  isDistributorAdmin,
  mayVisit,
  distributorMayVisit,
  DISTRIBUTOR_CLINIC_SHIPMENTS,
} from './roles';

// Navigation is cosmetic. Protected routes and the API still enforce access.
export function visibleGroups(user) {
  if (!canLogInToWeb(user?.role)) return [];
  const allowed = isDistributorAdmin(user)
    ? (item) => !item.masterOnly && mayVisit(user, item.path)
    : isAdmin(user)
      ? (item) => !item.repOnly && !item.masterOnly && !item.distributorClinicOnly
      : user.role === 'master_distributor'
        ? (item) => distributorMayVisit(item.path)
        : user.role === 'clinic' && Boolean(user.distributor)
          ? (item) =>
              [
                '/orders',
                '/ivr-details',
                DISTRIBUTOR_CLINIC_SHIPMENTS,
                '/resources',
                '/help-center',
                '/settings',
              ].includes(item.path)
          : (item) => mayVisit(user, item.path);
  const groups = isDistributorAdmin(user) ? DISTRIBUTOR_ADMIN_GROUPS : NAV_GROUPS;
  return groups
    .map((group) => ({ ...group, items: group.items.filter(allowed) }))
    .filter((group) => group.items.length > 0);
}

export const canSwitchWorkspace = (user) => isAdmin(user) && !isDistributorAdmin(user);

export function adminWorkspaceForPath(pathname) {
  return ['/admin/distributor-overview', '/admin/distributor-payment-test'].includes(pathname) ||
    NAV_GROUPS.find((group) => group.label === 'Distributor')?.items.some(
      (item) => pathname === item.path || pathname.startsWith(`${item.path}/`)
    )
    ? 'distributor'
    : 'medeffects';
}

export function workspaceGroups(user, pathname) {
  const groups = visibleGroups(user);
  if (!canSwitchWorkspace(user)) return groups;
  const distributor = adminWorkspaceForPath(pathname) === 'distributor';
  return groups.filter((group) => (group.label === 'Distributor') === distributor);
}

export function sidebarFirstName(user) {
  // Preserve the actual first-name field, including compound names. Never show a surname/email.
  return typeof user?.firstName === 'string' ? user.firstName.trim() : '';
}
